import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { push } from 'connected-react-router';
import Toolbar from '@mui/material/Toolbar';
import AppBar from '@mui/material/AppBar';
import { getTranslate } from 'react-localize-redux';
import { Stack, Box, Typography, Container, IconButton } from '@mui/material';
import withMediaQuery from '../withMediaQuery';
import { ReactComponent as AgendaIcon } from '../../assets/kind_icons/agenda-icon.svg';
import { ReactComponent as ChatIcon } from '../../assets/kind_icons/chat-icon.svg';
import { ReactComponent as LibraryIcon } from '../../assets/kind_icons/library-icon.svg';
import { ReactComponent as ColleaguesIcon } from '../../assets/kind_icons/colleagues-icon.svg';
import { setSelectedBottomTab } from '../Users/actions/usersActions';

const BottomBar = ({ push, selectedBottomTab, setSelectedBottomTab, ...props }) => {
	useEffect(() => {
		if (!selectedBottomTab) {
			if (props.scopes.includes('navigation.bottom_cases')) {
				setSelectedBottomTab('contacts');
			} else if (props.scopes.includes('navigation.bottom_chat')) {
				setSelectedBottomTab('chat');
			}
		}
	}, [selectedBottomTab, props.scopes, setSelectedBottomTab]);

	const goToContacts = () => push('/contacts');
	const goToChat = () => {
		const token = props.whoami?.settings?.['default.ticket.login']?.token;
		push(`/case/${token}`);
	};
	const goToCalendar = () => push('/mycalendar');
	const goToArticle = () => push('/articles');
	const goToBooking = () => push('/appointment');

	const handleTabClick = (tabId, action) => {
		setSelectedBottomTab(tabId);
		action();
	};

	const iconItems = [
		{
			id: 'contacts',
			label: props.translate('bottom_bar_chat'),
			icon: <ChatIcon width={28} height={28} />,
			display: props.scopes.includes('navigation.bottom_cases'),
			action: () => handleTabClick('contacts', goToContacts),
		},
		{
			id: 'chat',
			label: props.translate('bottom_bar_chat'),
			icon: <ChatIcon width={28} height={28} />,
			display: props.scopes.includes('navigation.bottom_chat'),
			action: () => handleTabClick('chat', goToChat),
		},
		{
			id: 'calendar',
			label: props.translate('bottom_bar_agenda'),
			icon: <AgendaIcon width={28} height={28} />,
			display: props.scopes.includes('navigation.bottom_calendar'),
			action: () => handleTabClick('calendar', goToCalendar),
		},
		{
			id: 'library',
			label: props.translate('bottom_bar_library'),
			icon: <LibraryIcon width={28} height={28} />,
			display: props.scopes.includes('navigation.bottom_library'),
			action: () => handleTabClick('library', goToArticle),
		},
		{
			id: 'colleagues',
			label: props.translate('bottom_bar_colleagues'),
			icon: <ColleaguesIcon width={28} height={28} />,
			display: props.scopes.includes('navigation.bottom_colleagues'),
			action: () => handleTabClick('colleagues', () => {}),
		},
		{
			id: 'meeting',
			label: props.translate('bottom_bar_meeting'),
			icon: <ColleaguesIcon width={28} height={28} />,
			display: props.scopes.includes('navigation.bottom_book_meeting'),
			action: () => handleTabClick('meeting', goToBooking),
		},
	];

	return (
		props.client && (
			<AppBar
				className="generic-bottombar-main"
				position="fixed"
				sx={{
					top: 'auto',
					bottom: 0,
					backgroundColor: '#fff',
					borderTop: '1px solid #e0e0e0',
					boxShadow: '0 -2px 6px rgba(0,0,0,0.08)',
					...(props.side_bar?.drawer_props?.variant === 'permanent' && {
						zIndex: (theme) => theme.zIndex.drawer + 1,
					}),
				}}
				id="default-layout-bottom-bar"
			>
				<Container maxWidth={false}>
					<Toolbar disableGutters sx={{ padding: 1 }}>
						<Stack
							direction="row"
							sx={{
								width: '100%',
								justifyContent: 'space-around',
								alignItems: 'center',
								overflow: 'auto',
							}}
						>
							{iconItems.map(
								(item, index) =>
									item.display && (
										<IconButton
											key={index}
											size="small"
											aria-label={item.label.toLowerCase()}
											onClick={item.action}
											sx={{
												p: 0,
												display: 'flex',
												flexDirection: 'column',
												color: item.id === selectedBottomTab ? '#DD6564' : '#444',
											}}
										>
											<Box sx={{ display: 'flex', justifyContent: 'center', mb: 0.3 }}>{item.icon}</Box>
											<Typography variant="body2" sx={{ color: item.id === selectedBottomTab ? '#DD6564' : '#444' }} fontSize="0.75rem">
												{item.label}
											</Typography>
										</IconButton>
									)
							)}
						</Stack>
					</Toolbar>
				</Container>
			</AppBar>
		)
	);
};

BottomBar.propTypes = {
	client: PropTypes.object,
	whoami: PropTypes.object,
	layouts: PropTypes.object,
	side_bar: PropTypes.object,
	selectedBottomTab: PropTypes.string,
	setSelectedBottomTab: PropTypes.func,
};

const mapStateToProps = (state) => ({
	client: state.login.client ?? null,
	whoami: state.users.whoami,
	translate: getTranslate(state.localize),
	layouts: state.generic.layouts,
	side_bar: state.generic.side_bar,
	scopes: state.users.whoami.scopes ? state.users.whoami.scopes : [],
	ticket: state.tickets.ticket,
	selectedBottomTab: state.users.selectedBottomTab,
});

const mapDispatchToProps = {
	push,
	setSelectedBottomTab,
};

export default connect(mapStateToProps, mapDispatchToProps)(withMediaQuery()(BottomBar));
